// Stops browsers and password managers from autofilling or suggesting saved
// logins into these fields. "new-password" is the value Chrome/Safari respect
// for password inputs (plain "off" is ignored); the data-* flags cover 1Password
// and LastPass.
export const NO_AUTOFILL_PROPS = {
  autoComplete: "new-password",
  inputProps: {
    autoComplete: "new-password",
    "data-1p-ignore": "true",
    "data-lpignore": "true",
  },
};
